import React, { Component, Fragment } from "react";
import { withRouter } from 'react-router-dom';
import AlertMessagePopUpModal from "../PopUp/AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "../PopUp/ConfirmMessagePopUpModal";
import GenAIGraphAddMilestone from './GenAIGraphAddMilestone'
import GenAIGraphViewMilestone from './GenAIGraphViewMilestone'

import moment from "moment";
import { Modal } from "react-bootstrap";
import { VegaLite } from 'react-vega'
import { isEqual } from 'underscore'
const GraphInProcessing = 'GraphInProcessing';
const GraphSucceeded = 'GraphSucceeded';
const GraphUnsucceeded = 'GraphUnsucceeded';

class GenAIGraphIndex extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            userGraphInfo: props.userGraphInfo,
            question: props.question,
            updatedQuestion: props.question,
            userGraphRequirements: props.userGraphRequirements,
            userSelectedGraphTypes: props.userSelectedGraphTypes,
            isInEditMode: false,
            responseHTML: '',
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            confirmMessageContent: '',
            confirmMessageShowModal: false,
            confirmMessageId: -1,
            iframeHeight: "800px",
            isOpenAddMilestone: false,
            isOpenViewMilestone: false,
        }
    }
    componentDidMount() {
    }
    handleEditQuestion = (e) => {
        this.setState({ updatedQuestion: e.target.value })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.userGraphInfo
            && this.props.userGraphInfo
            && (nextProps.userGraphInfo.userGraphHTML !== this.props.userGraphInfo.userGraphHTML
                || nextProps.userGraphInfo.graphAPIStatus !== this.props.userGraphInfo.graphAPIStatus
                || nextProps.userGraphInfo.graphAPIResponseThreadId !== this.props.userGraphInfo.graphAPIResponseThreadId
                || nextProps.userGraphInfo.userGraphBase64 !== this.props.userGraphInfo.userGraphBase64
                || !isEqual(nextProps.userGraphInfo.spec, this.props.userGraphInfo.spec)

            )) {
            this.setState({ userGraphInfo: nextProps.userGraphInfo });
        }
        if (nextProps.question
            && this.props.question
            && nextProps.question !== this.props.question) {
            this.setState({ question: nextProps.question });
        }
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    showConfirmMessage = (message, id) => {
        this.setState({
            confirmMessageContent: message,
            confirmMessageShowModal: true,
            confirmMessageId: id
        })
    }

    confirmHandler = async () => {
        this.setState(
            {
                confirmMessageContent: "",
                confirmMessageShowModal: false,
                // confirmMessageId: -1
            },
            async () => {
                let { question } = this.state;
                await this.props.updateRunGenAIGraphSearch(question);
            }
        );
    }

    closeConfirmMessage = () => {
        this.setState({
            confirmMessageContent: "",
            confirmMessageShowModal: false,
            confirmMessageIndex: -1
        })
    }
    handleClickOnCancelEditQuestion = (e) => {
        this.setState({
            isInEditMode: false,
            updatedQuestion: this.state.question
        })
    }
    handleClickOnSaveEditQuestion = async (e) => {
        let { updatedQuestion } = this.state;
        await this.props.updateRunGenAIGraphSearch(updatedQuestion);
        this.setState({
            isInEditMode: false,
        })
    }
    handleClickOnEditQuestion = () => {
        this.setState({
            isInEditMode: !this.state.isInEditMode,
            updatedQuestion: this.state.question,
        }, () => {
            this.scrollToBottom();
        })
    }
    handleClickOnAddMilestone = () => {
        this.setState({ isOpenAddMilestone: true });
    }
    handleClickOnViewMilestone = () => {
        this.setState({ isOpenViewMilestone: true });
    }
    scrollToBottom = () => {
        //this.messagesEndRef.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    }
    handleClickOnRewriteAnswer = () => {
        this.showConfirmMessage("Are you sure you want to refresh the graph?", "")
    }
    resizeIframe = () => {
        if (this.userGraphiframe && this.userGraphiframe.contentWindow
            && this.userGraphiframe.contentWindow.document
            && this.userGraphiframe.contentWindow.document.body
            && this.userGraphiframe.contentWindow.document.body.scrollHeight) {
            this.setState({
                iframeHeight: `${parseInt(this.userGraphiframe.contentWindow.document.body.scrollHeight) + 20}px`
            })
        }
    }
    handleAddMilestoneClose = () => {
        this.setState({
            isOpenAddMilestone: false
        })
    }
    handleViewMilestoneClose = () => {
        this.setState({
            isOpenViewMilestone: false
        })
    }
    handleClickOnRevertToMilestone = async (_userGraphInfo, _userSelectedGraphTypes, _userGraphRequirements, _question) => {
        return await this.props.handleClickOnRevertToMilestone(_userGraphInfo, _userSelectedGraphTypes, _userGraphRequirements, _question)
    }
    renderAddMilestoneModelPopup = () => {
        let { isOpenAddMilestone, customWidth, userGraphInfo, question, userGraphRequirements, userSelectedGraphTypes } = this.state;
        return (<Modal
            show={isOpenAddMilestone}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="authoring-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}>
            <Modal.Body>
                <div style={{ overflow: "auto" }}>
                    <GenAIGraphAddMilestone customWidth={customWidth} userGraphInfo={userGraphInfo} indexAddMilestoneData={this.props.indexAddMilestoneData} handleClose={this.handleAddMilestoneClose} question={question}
                        userGraphRequirements={userGraphRequirements} userSelectedGraphTypes={userSelectedGraphTypes} />
                </div>
            </Modal.Body>
        </Modal>)
    }
    renderViewMilestoneModelPopup = () => {
        let { isOpenViewMilestone, customWidth, userGraphInfo, question } = this.state;
        return (<Modal
            show={isOpenViewMilestone}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="authoring-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}>
            <Modal.Body>
                <div style={{ overflow: "auto" }}>
                    <GenAIGraphViewMilestone handleClickOnRevertToMilestone={this.handleClickOnRevertToMilestone} customWidth={customWidth} userGraphInfo={userGraphInfo} handleClose={this.handleViewMilestoneClose}
                        question={question} indexReverttoMilestoneData={this.props.indexReverttoMilestoneData} />
                </div>
            </Modal.Body>
        </Modal>)
    }
    render() {
        let { question, isInEditMode, updatedQuestion, userGraphInfo, iframeHeight } = this.state;
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        const { confirmMessageContent, confirmMessageShowModal } = this.state;
        let isDisable = question === updatedQuestion;
        if (this.state.customWidth >= 600 && this.state.customWidth <= 1000) {
            return (<></>)
        }
        else if (this.state.customWidth > 1000) {
            return (<><div className="gen-ai-answering-graph-main">
                <div className="gen-ai-answering-graph-top">
                    <div className="gen-ai-answering-graph-top-controle">
                        <div className="gen-ai-answering-graph-top-controle-left">
                        </div>
                        <div className="gen-ai-answering-graph-top-controle-right">
                            <div className="gen-ai-answering-graph-top-controle-right-milestone-section">
                                {/* {(userGraphInfo && userGraphInfo.graphAPIStatus === GraphSucceeded) &&
                                    <button type="button" onClick={this.handleClickOnAddMilestone} className="gen-ai-answering-result-main-answer-control-edit" title="Add Milestone" data-state="closed">
                                        <svg viewBox="0 0 24 24" height="24px" width="24px" data-prefix="far" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier">
                                                <path d="M16.577 8.52566L6.65811 5.21937C6.3578 5.11927 6.20764 5.06921 6.10382 5.14405C6 5.21888 6 5.37716 6 5.69371V13L16.577 9.47434C17.1653 9.27824 17.4594 9.18019 17.4594 9C17.4594 8.81981 17.1653 8.72176 16.577 8.52566Z" fill="#222222"></path>
                                                <path d="M6 13V5.69371C6 5.37716 6 5.21888 6.10382 5.14405C6.20764 5.06921 6.3578 5.11927 6.65811 5.21937L16.577 8.52566C17.1653 8.72176 17.4594 8.81981 17.4594 9C17.4594 9.18019 17.1653 9.27824 16.577 9.47434L6 13ZM6 13V18V19" stroke="#222222" stroke-width="2" stroke-linecap="round"></path>
                                            </g>
                                        </svg>
                                        Add Milestone
                                    </button>
                                }
                                <button type="button" onClick={this.handleClickOnViewMilestone} className="gen-ai-answering-result-main-answer-control-rewrite" title="View Milestones" data-state="closed">
                                    <svg style={{ marginRight: "2px" }} fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 100 100" enable-background="new 0 0 100 100">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <g>
                                                    <path d="M85.088,80.271c2.715,0,4.912-2.2,4.912-4.917V24.645c0-2.717-2.197-4.917-4.912-4.917H14.912 c-2.714,0-4.912,2.2-4.912,4.917v50.709c0,2.717,2.197,4.917,4.912,4.917H85.088z M80.175,70.443h-60.35V29.556h60.35V70.443z"></path> </g> <g> <g> <path d="M41.564,65.897c-0.927,0-1.819-0.37-2.481-1.029l-4.896-4.897l-5.96,4.932c-1.5,1.242-3.708,1.024-4.942-0.466 c-1.234-1.495-1.026-3.71,0.466-4.941l8.424-6.969c1.394-1.156,3.434-1.06,4.719,0.223l4.072,4.075l8.979-13.989 c0.69-1.07,1.874-1.688,3.181-1.602c1.272,0.082,2.4,0.846,2.945,2.002l5.299,11.206L71.602,36.45 c0.96-1.688,3.099-2.266,4.787-1.318c1.683,0.963,2.273,3.102,1.315,4.79L64.133,63.784c-0.646,1.135-1.901,1.82-3.183,1.769 c-1.31-0.046-2.481-0.821-3.041-2.008l-5.479-11.591L44.516,64.28c-0.573,0.897-1.521,1.48-2.577,1.597 C41.815,65.887,41.688,65.897,41.564,65.897z"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    View Milestones
                                </button> */}
                            </div>
                        </div>
                    </div>
                    {/* {(userGraphInfo && userGraphInfo.graphAPIStatus === GraphSucceeded) && <iframe srcDoc={userGraphInfo.userGraphHTML} width="100%" height="800px" />} */}
                    {(userGraphInfo && userGraphInfo.userGraphHTML && userGraphInfo.graphAPIStatus === GraphSucceeded) && <iframe srcDoc={userGraphInfo.userGraphHTML}
                        title="Generated graph"
                        ref={ref => { this.userGraphiframe = ref }}
                        width="100%"
                        height={iframeHeight}

                        onLoad={this.resizeIframe}
                        frameborder="0" scrolling="no" />}

                    {(userGraphInfo && userGraphInfo.userGraphBase64 && userGraphInfo.graphAPIStatus === GraphSucceeded) &&

                        <img src={`data:image/jpeg;base64,${userGraphInfo.userGraphBase64}`} alt="Generated graph" />
                    }
                    {(userGraphInfo && userGraphInfo.spec && userGraphInfo.graphAPIStatus === GraphSucceeded) &&
                        <VegaLite spec={userGraphInfo.spec} />
                    }
                    {(userGraphInfo && userGraphInfo.graphAPIStatus === GraphUnsucceeded) && <div width="100%" className="gen-ai-answering-graph-no-graph" >
                        <p>
                            <svg fill="#000000" height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier"> <g>
                                    <g>
                                        <path d="M435.36,281.015c-42.262,0-76.64,34.378-76.64,76.64c0,42.262,34.378,76.64,76.64,76.64S512,399.917,512,357.655 C512,315.393,477.622,281.015,435.36,281.015z M435.36,417.264c-32.865,0-59.609-26.744-59.609-59.609 s26.744-59.609,59.609-59.609s59.609,26.744,59.609,59.609S468.225,417.264,435.36,417.264z"></path>
                                    </g>
                                </g>
                                    <g>
                                        <g>
                                            <path d="M447.401,357.655l19.526-19.526c3.326-3.326,3.326-8.715,0-12.041c-3.326-3.326-8.715-3.326-12.042,0l-19.526,19.526 l-19.526-19.526c-3.326-3.326-8.715-3.326-12.041,0c-3.326,3.326-3.326,8.715,0,12.041l19.526,19.526l-19.526,19.526 c-3.326,3.326-3.326,8.715,0,12.042c1.663,1.663,3.842,2.495,6.021,2.495c2.179,0,4.358-0.832,6.021-2.495l19.526-19.526 l19.526,19.526c1.663,1.663,3.842,2.495,6.021,2.495s4.358-0.832,6.021-2.495c3.326-3.326,3.326-8.715,0-12.042L447.401,357.655z"></path>
                                        </g>
                                    </g>
                                    <g>
                                        <g> <path d="M469.48,18.096H26.553C12.499,18.096,0,28.507,0,42.619v8.433c0,11.12,8.516,20.507,17.031,24.029v248.495 c0,14.096,12.516,26.628,26.586,26.628h186.304v59.405c-19.16,3.956-33.53,21.156-33.53,41.717 c0,23.476,19.368,42.578,42.844,42.578s42.179-19.102,42.179-42.578c0-20.561-13.173-37.761-34.461-41.717v-59.405h69.189 c4.707,0,8.516-3.809,8.516-8.516c0-4.707-3.809-8.516-8.516-8.516H43.617c-4.682,0-9.555-4.89-9.555-9.597V77.705h425.78v160.732 c0,4.707,3.809,8.516,8.516,8.516s8.516-3.809,8.516-8.516V75.081c10.645-3.522,17.031-12.909,17.031-24.029v-8.433 C493.904,28.507,483.534,18.096,469.48,18.096z M265.048,451.326c0,14.087-11.459,25.547-25.547,25.547 s-25.547-11.459-25.547-25.547s11.459-25.547,25.547-25.547S265.048,437.239,265.048,451.326z M476.873,51.052 c0,4.715-2.728,9.622-7.393,9.622h-0.058H26.611h-0.058c-4.665,0-9.522-4.906-9.522-9.622v-8.433c0-4.715,4.857-7.493,9.522-7.493 H469.48c4.665,0,7.393,2.778,7.393,7.493V51.052z"></path> </g> </g> <g> <g> <path d="M367.235,265.048H127.734V110.703c0-4.707-3.809-8.516-8.516-8.516c-4.707,0-8.516,3.809-8.516,8.516v154.345H94.736 c-4.707,0-8.516,3.809-8.516,8.516s3.809,8.516,8.516,8.516h15.967v15.967c0,4.707,3.809,8.516,8.516,8.516 c4.707,0,8.516-3.809,8.516-8.516v-15.967h239.501c4.707,0,8.516-3.809,8.516-8.516S371.942,265.048,367.235,265.048z"></path> </g> </g> <g> <g> <path d="M195.859,179.892h-42.578c-4.703,0-8.516,3.813-8.516,8.516v59.609c0,4.703,3.813,8.516,8.516,8.516h42.578 c4.703,0,8.516-3.813,8.516-8.516v-59.609C204.374,183.705,200.561,179.892,195.859,179.892z M187.343,239.501h-25.547v-42.578 h25.547V239.501z"></path> </g> </g> <g> <g> <path d="M281.015,137.314h-42.578c-4.703,0-8.516,3.813-8.516,8.516v102.187c0,4.703,3.813,8.516,8.516,8.516h42.578 c4.703,0,8.516-3.813,8.516-8.516V145.83C289.53,141.127,285.717,137.314,281.015,137.314z M272.499,239.501h-25.547v-85.156 h25.547V239.501z"></path> </g> </g> <g> <g> <path d="M366.17,103.252h-42.578c-4.703,0-8.516,3.813-8.516,8.516v136.249c0,4.703,3.813,8.516,8.516,8.516h42.578 c4.703,0,8.516-3.813,8.516-8.516V111.767C374.686,107.064,370.873,103.252,366.17,103.252z M357.655,239.501h-25.547V120.283 h25.547V239.501z"></path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            &nbsp;
                            No graph found. Please try a new prompt.
                        </p>
                    </div>}
                    {(userGraphInfo && userGraphInfo.graphAPIStatus === GraphInProcessing) && <div width="100%" className="gen-ai-answering-graph-no-graph" >
                        <p>
                            &nbsp;
                        </p>
                    </div>}
                    {/* {responseHTML && <div dangerouslySetInnerHTML={{ __html: (`${responseHTML}`) }} />} */}

                </div>
                <div className="gen-ai-answering-graph-bottom">
                    <div className="gen-ai-answering-graph-prompt-section">
                        <div className="gen-ai-answering-graph-prompt-left">
                            <div className="gen-ai-answering-graph-prompt-header-icon">
                                <svg width="24px" height="24px" viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M143.04 839.552c43.584 0 79.104-35.52 79.104-79.104v-448a79.168 79.168 0 0 0-158.08 0l-0.064 448c0 43.584 35.456 79.104 79.04 79.104z m-26.368-527.104a26.368 26.368 0 0 1 52.736 0v448a26.368 26.368 0 0 1-52.736 0v-448z m263.552 527.104c43.584 0 79.04-35.52 79.04-79.104V523.264c0-43.52-35.456-79.04-79.04-79.04s-79.04 35.456-79.04 79.04v237.184c0 43.584 35.456 79.104 79.04 79.104zM353.92 523.264a26.368 26.368 0 0 1 52.736 0v237.184a26.368 26.368 0 0 1-52.736 0V523.264z m500.736 316.288c43.584 0 79.04-35.52 79.04-79.104v-158.08c0-43.584-35.456-79.104-79.04-79.104s-79.04 35.52-79.04 79.104v158.08c0 43.584 35.456 79.104 79.04 79.104z m-26.368-237.184a26.368 26.368 0 0 1 52.736 0v158.08a26.368 26.368 0 0 1-52.736 0v-158.08z m-210.816 237.184c43.584 0 79.04-35.52 79.04-79.104V207.04c0-43.52-35.456-79.04-79.04-79.04s-79.04 35.456-79.04 79.04v553.408c0 43.584 35.456 79.104 79.04 79.104z m-26.368-632.512a26.368 26.368 0 0 1 52.736 0v553.408a26.368 26.368 0 0 1-52.736 0V207.04zM64 892.224h896v52.736H64v-52.736z" fill="#000000"></path>
                                    </g>
                                </svg>
                            </div>
                            &nbsp;
                            <div className="gen-ai-answering-graph-prompt-prompt-title"> Prompt</div>
                        </div>
                        <div className="gen-ai-answering-graph-prompt-right">
                            {!isInEditMode &&
                                <div className="gen-ai-answering-graph-question-control-section">
                                    <button type="button" onClick={this.handleClickOnEditQuestion} className="gen-ai-answering-result-main-answer-control-edit" title="Rewrite" data-state="closed">
                                        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="pen-to-square" className="svg-inline--fa fa-pen-to-square fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z">
                                            </path>
                                        </svg>
                                        Rewrite
                                    </button>
                                    <button type="button" onClick={this.handleClickOnRewriteAnswer} className="gen-ai-answering-result-main-answer-control-rewrite" title="Refresh Answer" data-state="closed">
                                        <svg height="18px" className="feather feather-repeat" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <polyline points="17 1 21 5 17 9" />
                                            <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                            <polyline points="7 23 3 19 7 15" />
                                            <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                        </svg>
                                        Refresh
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                    {isInEditMode ?
                        <div className="gen-ai-answering-graph-update-question">
                            <div className="gen-ai-answering-graph-update-question-textarea-section">
                                <textarea placeholder="" className="" onChange={(e) => this.handleEditQuestion(e)} value={updatedQuestion} />
                            </div>
                            <div className="gen-ai-answering-graph-update-question-control">
                                <button onClick={this.handleClickOnCancelEditQuestion} type="button" className="gen-ai-answering-graph-update-question-cancel">
                                    Cancel
                                </button>
                                <button type="button" onClick={this.handleClickOnSaveEditQuestion} disabled={isDisable} className="gen-ai-answering-graph-update-question-save">
                                    Save
                                </button>
                            </div>
                        </div>
                        : <>
                            <div className="gen-ai-answering-graph-question">
                                <h2 className="gen-ai-answering-graph-question-h2">{question}</h2>
                            </div>
                        </>}
                    <div className="gen-ai-answering-result-main-answer-control">
                        <div className="gen-ai-answering-result-main-answer-control-left">
                            &nbsp;
                        </div>
                        <div className="gen-ai-answering-result-main-answer-control-right">
                            {(userGraphInfo && userGraphInfo.lastCreatedDatehour) && <div className="gen-ai-graph-library-thread-item-time-ago" title={moment(userGraphInfo.lastCreatedDatehour).format("MMM DD, YYYY hh:mm a")} data-state="closed">
                                <span>
                                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="clock" className="svg-inline--fa fa-clock fa-sm " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path fill="currentColor" d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"></path>
                                    </svg>
                                </span>
                                <span className="truncate">&nbsp; {moment(userGraphInfo.lastCreatedDatehour).format("MMM DD, YYYY hh:mm a")}</span>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
                {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} btnText="Yes" />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                {this.renderAddMilestoneModelPopup()}
                {this.renderViewMilestoneModelPopup()}
            </>)
        }
    }
}
export default withRouter(GenAIGraphIndex);